import globals from '../globlas';

const { BlobServiceClient } = require('@azure/storage-blob');

const AZURE_CONNECTION_STRING = globals.REACT_APP_AZURE_CONNECTION_STRING;

const blobService = new BlobServiceClient(AZURE_CONNECTION_STRING);

export const uploadAzure = async (nome, file, size, folder, handlerProgress) => {
    const containerClient = blobService.getContainerClient(folder);
    const blockBlobClient = containerClient.getBlockBlobClient(nome);
    
    const uploadResponse = await blockBlobClient.uploadData(file, {
        blobHTTPHeaders: {
            blobContentType: file.type
        },
        onProgress(state) {
            handlerProgress(state.loadedBytes, size);
        }
    });
    return uploadResponse;
}
export const downloadAzure = async (url, nome, folder) => {
    const containerClient = blobService.getContainerClient(folder);
    const blockBlobClient = containerClient.getBlockBlobClient(nome);

    let result = await blockBlobClient.download();
 
}

